const SYMBOL_ALIASES: Record<string, string> = {};

export function resolveSignalForgeSymbol(brokerSymbol: string): string {
  const upper = brokerSymbol.trim().toUpperCase();
  return SYMBOL_ALIASES[upper] ?? upper;
}
